
import { axios } from '@/utils/request'

const api = { 
  getApplyList: '/wyhadminapi/dabiao/shengManageList',
  getMemberList: '/wyhadminapi/dabiao/shengList',
  checkShengMemberOK: '/wyhadminapi/dabiao/checkShengMemberOK',
  shengcpApply: '/wyhadminapi/dabiao/shengApply',
  shengApplyDetail: '/wyhadminapi/dabiao/shengApplyDetail',
  xlsxImport: '/wyhadminapi/dabiao/xlsxImport',
}

export default api 
export function getApplyList(parameter) {
  return axios({
    url: api.getApplyList,
    method: 'get',
    params: parameter
  })
}
export function getMemberList(parameter) {
  return axios({
    url: api.getMemberList,
    method: 'get',
    params: parameter
  })
}
export function checkShengMemberOK(parameter) {
  return axios({
    url: api.checkShengMemberOK,
    method: 'post',
    data: parameter
  })
}
export function shengApply(parameter) {
  return axios({
    url: api.shengcpApply,
    method: 'post',
    data: parameter
  })
}
export function xlsxImport(parameter) {
  return axios({
    url: api.xlsxImport,
    method: 'post',
    headers: {
      'Content-Type':'multipart/form-data'
    },
    data: parameter
  })
}
export function getShengApplyDetail(parameter) {
  return axios({
    url: api.shengApplyDetail,
    method: 'post',
    data: parameter
  })
}
